let language = {
    "PAYPAL_PAYMENT_FAILED_TITLE": "Paypal password-free payment failed",
    "PAYPAL_DECLINED_TRANSACTION_TITLE": "PayPal payment failed",

    "CHECK_PASSWORD_PAYMENT_SETTING": "Your PayPal password-free payment has failed. Please disconnect and refresh the page to try again.",
    "CHECK_PAYMENT_SETTING": "Please check your PayPal account settings; we are currently unable to connect to your PayPal account for payment.",
    "CHECK_PAYMENT_SETTING_OR_ACCOUNT_BALANCE": "Your account seems to be unable to connect or has insufficient balance, so we are currently unable to connect to your PayPal account for payment.",
    "TRY_PAYMENT_AGAIN": "PayPal payment failed, please try again later",
    "PAYPAL_REDIRECTION_FAILED_TITLE": "PayPal redirection failed",
    "PAYPAL_REDIRECTION_FAILED_CONTENT": "Opps, payPal payment redirection failed, Please to try again later.",
};

export { language }